import { ENV } from "hub/src/appConstants/env";

export const isIframeSSOPage =
  top !== self &&
  ENV.REACT_APP_IFRAME_SSO_REDIRECT_URL &&
  ENV.REACT_APP_IFRAME_SSO_PATH;
